import roundTo from 'round-to';

export const getPercentage = a => (a * 100);

export const formatNumberOrDash = (value, precision, prefix, suffix, sub) => {
  const p = prefix ? `${prefix} ` : '';
  const s = suffix ? ` ${suffix}` : '';
  let result = typeof sub === 'string' ? sub : '-';

  if (value != null && !Number.isNaN(value)) {
    result = ` ${p}${roundTo(value, Number(precision || 0)).toFixed(precision)}${s}`.trim();
  }
  return result;
};
